
    <div class="stepper-container">
      <!-- Step Label -->
      <div class="tw-text-black tw-font-semibold">
        Paso {{ currentStep }} de {{ totalSteps }}
      </div>
      <!-- Circular Progress -->
      <div class="progress-container">
        <div
          class="progress-circle"
          [ngStyle]="{
            background: conicBackground,
            transform: 'rotate(0deg)'
          }"
        ></div>
        <div class="progress-cover"></div>
      </div>
    </div>
  